<template>
  <div class="mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center px-4 py-20">
    <div class="panel w-full max-w-2xl p-8 text-center">
      <p class="text-xs uppercase tracking-[0.35em] text-[var(--accent)]">404</p>
      <h1 class="mt-4 text-4xl font-bold text-[var(--text-primary)] md:text-6xl">
        {{ $t('error.message') }}
      </h1>
      <p class="mt-4 text-sm text-[var(--text-muted)]">
        {{ $t('error.home') }}
      </p>
      <div class="mt-6 flex justify-center">
        <button class="btn-primary" @click="goBack">
          {{ $t('error.home') }}
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: "ErrorPage",
    methods: {
      goBack() {
        this.$router.push("/");
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  